<div class="fuse-delete-modal dialog-content-wrapper">
  <div class="unsave-header">{{ 'tasks.reject_title' | translate }}</div>
  <div mat-dialog-content class="m-0">
    <p class="unsave-data-text">
      <mat-icon>info</mat-icon>
      <span>{{ 'tasks.reject_confirm' | translate }}</span>
    </p>
    <mat-form-field style="width:100%">
      <mat-label>{{ 'tasks.admin_comment' | translate }}</mat-label>
      <textarea matInput [(ngModel)]="adminComment" rows="3"></textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="m-0 p-10 unsave-footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button (click)="confirm()">{{ 'button.confirm' | translate }}</button>
    <button mat-button (click)="dialogRef.close()">{{ 'button.cancel' | translate }}</button>
  </div>
</div>
